/**
 * Builds grid customizer configuration for a quote content tab.
 * Relies on global `quosal` and `app` (legacy host globals).
 */
export const getGridConfig = (tabId, layoutName) => {
	const gridLayouts = quosal.customization.grids.QuoteContent.Configurations;
	const quoteTab = app.currentQuote?.Tabs?.find((tab) => tab.IdQuoteTabs === tabId);
	const layout =
		!quoteTab || gridLayouts[quoteTab.GridFormat] == undefined
			? gridLayouts.Default
			: gridLayouts[quoteTab.GridFormat];

	return {
		gridName: "QuoteContent",
		configurationName: layoutName,
		fieldList: "QuoteItems",
		boVersion: layout.BoVersion
	};
};
